/* eslint-disable import/prefer-default-export */

export const ACTIVE_PAGE_CHANGED = 'ACTIVE_PAGE_CHANGED';
